import { render, staticRenderFns } from "./EsgDisclosureTemplateDetail.vue?vue&type=template&id=2236be85&scoped=true"
import script from "./EsgDisclosureTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EsgDisclosureTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./EsgDisclosureTemplateDetail.vue?vue&type=style&index=0&id=2236be85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236be85",
  null
  
)

export default component.exports